type VersionedRecipeLike = {
  id: string
  version?: string
  isActive?: boolean
  is_active?: boolean
  updatedAt?: string | Date
  updated_at?: string
}

function isActiveRecipe(recipe: VersionedRecipeLike) {
  return Boolean(recipe.isActive ?? recipe.is_active)
}

function updatedAtMs(recipe: VersionedRecipeLike) {
  const value = recipe.updatedAt ?? recipe.updated_at
  if (!value) return 0
  const date = value instanceof Date ? value : new Date(value)
  return Number.isNaN(date.getTime()) ? 0 : date.getTime()
}

function shouldPreferRecipe(candidate: VersionedRecipeLike, current: VersionedRecipeLike) {
  const candidateActive = isActiveRecipe(candidate)
  const currentActive = isActiveRecipe(current)
  if (candidateActive !== currentActive) return candidateActive

  return updatedAtMs(candidate) > updatedAtMs(current)
}

export function dedupeRecipesById<T extends VersionedRecipeLike>(recipes: T[]): T[] {
  const byId = new Map<string, T>()

  for (const recipe of recipes) {
    if (!recipe.id) continue

    const current = byId.get(recipe.id)
    if (!current || shouldPreferRecipe(recipe, current)) {
      byId.set(recipe.id, recipe)
    }
  }

  return [...byId.values()]
}

export function recipeListKey(recipe: VersionedRecipeLike, index: number) {
  return `${recipe.id}:${recipe.version || 'unversioned'}:${index}`
}
